import { PerfectiveVerb } from '../../types'

const проебать: PerfectiveVerb = {
  type: 'perfective verb',
  infinitive: 'проебать',
  imperativePluralSecondPerson: 'проебите',
  imperativeSingularSecondPerson: 'проеби',
  indicativeFuturePluralFirstPerson: 'проебём',
  indicativeFuturePluralSecondPerson: 'проебёте',
  indicativeFuturePluralThirdPerson: 'проебут',
  indicativeFutureSingularFirstPerson: 'проебу',
  indicativeFutureSingularSecondPerson: 'проебёшь',
  indicativeFutureSingularThirdPerson: 'проебёт',
  indicativePastPlural: 'проебали',
  indicativePastSingularFeminine: 'проебала',
  indicativePastSingularMasculine: 'проебал',
  indicativePastSingularNeuter: 'проебало',
}

export default проебать
